import React from "react";

import { Grid, Layout } from "antd";
// import { ExclamationCircleOutlined } from "@ant-design/icons";

//import localization
// import { useTranslation } from "react-i18next";

import InteramericanLogo from "../images/LOGO.jpg";
// import EnglishIcon from "../images/english-icon.png";
// import GreekIcon from "../images/greek-icon.png";
// import RussianIcon from "../images/russian-icon.png";

const { useBreakpoint } = Grid;
const { Header } = Layout;
// const { SubMenu } = Menu;
// const { confirm } = Modal;

function NavBarView({ currentStep, query }) {
	//Locale Hooks
	// const { t } = useTranslation();

	//Controller for window resizing.
	//Used in: Header
	const screen = useBreakpoint();

	// const onLanguageChange = ({ key }) => {
	// 	if (currentStep > 0) {
	// 		confirm({
	// 			icon: <ExclamationCircleOutlined />,
	// 			title: t("Warning"),
	// 			content: <div>{t("WarningContentLanguage")}</div>,
	// 			cancelText: t("No"),
	// 			okText: t("Yes"),
	// 			centered: true,
	// 			maskClosable: true,

	// 			onOk() {
	// 				window.location.href = `/travel?ch=${query.Channel}&lg=${key}`;
	// 			},
	// 			onCancel() {}
	// 		});
	// 	} else {
	// 		window.location.href = `/travel?ch=${query.Channel}&lg=${key}`;
	// 	}
	// };

	// Set up for english only view
	return (
		<Header style={{ background: "#ed1b24", textAlign: screen.xs || (screen.sm && !screen.md) ? "left" : "center" }}>
			<img src={InteramericanLogo} alt="Logo" className="logo" style={{ margin: "0px 0px 0px 90px" }} />
			{/* <img src={InteramericanLogo} alt="Logo" className="logo" style={{ margin: currentStep !== 4 && "0px 0px 0px 90px" }} /> */}
			{currentStep !== 4 && (
				<></>
				// <Menu className="header-menu" mode="horizontal" onClick={onLanguageChange}>
				// 	<SubMenu title={t("Language")} style={{ background: "#ed1b24" }}>
				// 		<Menu.Item icon={<img src={EnglishIcon} alt="en-GB" width={24} style={{ borderRadius: 15 }} />} key="en-GB">
				// 			{t("English")}
				// 		</Menu.Item>
				// 		<Menu.Item icon={<img src={GreekIcon} alt="el-GR" width={24} style={{ borderRadius: 15 }} />} key="el-GR">
				// 			{t("Greek")}
				// 		</Menu.Item>
				// 		<Menu.Item icon={<img src={RussianIcon} alt="ru-RU" width={24} style={{ borderRadius: 15 }} />} key="ru-RU">
				// 			{t("Russian")}
				// 		</Menu.Item>
				// 	</SubMenu>
				// </Menu>
			)}
		</Header>
	);
}

export default React.memo(NavBarView);
